<template>
  <el-row>
    <el-col>
      <el-card shadow="never">
        <BillingEditForm
          ref="editForm"
          :account-id="accountId"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import BillingEditForm from '@/components/Application/Manage/Account/BillingEditForm'

export default {
  components: {
    BillingEditForm
  },
  data () {
    return {
      accountId: this.$route.params.accountId,
      actions: [
        {
          name: 'Save',
          icon: ['fal', 'save'],
          event: () => {
            this.$refs.editForm.saveBillingEdit()
          }
        },
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: () => {
            this.$refs.editForm.readAccount()
          }
        }
      ],
      breadcrumb: {
        name: 'Billing',
        route: { name: 'manage-accounts-account-configurations-billing', params: { accountId: this.$route.params.accountId } }
      }
    }
  }
}
</script>

<style>

</style>
